import { AxiosResponse } from 'axios';
import { MutationOptions, useMutation } from '@tanstack/react-query';
import { deleteUploadedListFile } from 'Services';
import { callAll } from 'Utils';

type HookArgs = {
    mutationOptions?: Omit<MutationOptions<AxiosResponse, unknown, unknown, unknown>, 'mutationKey'>;
};

const useDeleteUploadedListFile = ({ mutationOptions }: HookArgs) => {
    return useMutation(deleteUploadedListFile, {
        onSuccess: callAll(mutationOptions?.onSuccess),
        onError: async (error, variables, context) => {
            mutationOptions?.onError?.(error, variables, context);
        }
    });
};

export default useDeleteUploadedListFile;
